export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-accent-500">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-background-50/20 text-background-50 mb-6">
            <i className="ri-smartphone-line text-3xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">
            随时随地吃瓜
          </h2>
          <p className="text-sm md:text-base text-accent-100 leading-relaxed mb-8 max-w-lg mx-auto">
            黑料718移动端已全面适配，无需下载APP，打开手机浏览器即可畅享流畅的吃瓜体验。收藏网站到手机桌面，每日新鲜黑料触手可及。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-100 text-accent-600 font-medium rounded-md text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-link-m text-lg"></i>
              打开移动版
            </a>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 border border-background-50/30 text-background-50 hover:bg-background-50/10 font-medium rounded-md text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-bookmark-line text-lg"></i>
              收藏到桌面
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}